import { useURL } from "@kalyzee/kast-web-sdk/web-components";
import { useCallback, useEffect, useSyncExternalStore } from "react";
import { getResolvedSettings, Settings, subscribeSettings, syncSettingsUrlOverlay, updateStoredSettings } from "../helpers/settings";

export const useSettings = (useUrlQuery: boolean = true): [settings: Settings, setSettings: (settings: Partial<Settings>, options?: { mergeWithExisting?: boolean, save?: boolean }) => Settings] => {
  const url = useURL();
  
  // Resolved 3-layer view: env (SETTINGS var) < `?settings=` URL overlay < localStorage.
  const settings = useSyncExternalStore(subscribeSettings, getResolvedSettings);

  useEffect(() => {
    if (!useUrlQuery) return;
    syncSettingsUrlOverlay(url.href);
  }, [url, useUrlQuery]);

  // Writes only touch the stored (localStorage) layer — never the env/URL overlays.
  const setSettings = useCallback((st: Partial<Settings>, options?: { mergeWithExisting?: boolean, save?: boolean }) => {
    return updateStoredSettings(st, { merge: options?.mergeWithExisting, persist: options?.save });
  }, []);

  return [settings, setSettings];
};
